import { Link } from 'react-router-dom';
import styled from 'styled-components';

import BackButton from 'components/back-button';
import HeroHeading from 'components/hero-heading';

import { SectionHeadingFontFamily } from './theme';

/**
 * Positions the content correctly on the page.
 *
 */
export const PageWrap = styled.div`
  padding-bottom: 204px;
  margin: 1rem 0;

  ${Styles.desktop`
    width: 90%;
    max-width: 650px;
    margin: 10rem auto 60px;
    padding-bottom: 60px;
  `}
`;

/**
 *  Page heading
 */
export const PageHeading = styled(HeroHeading)`
  font-size: 2.1rem;
  font-weight: normal;
  text-transform: uppercase;
  color: ${Styles.color.black};
  margin-bottom: 1rem;

  ${Styles.desktop`
    text-align: center;
    font-size: 4rem;
    margin-bottom: 1.5rem;
  `};
`;

/**
 * Heading for page sections
 */
export const SectionHeading = styled.h2`
  margin: 0;
  font-size: 1.125rem;
  font-family: ${SectionHeadingFontFamily};
  text-transform: uppercase;
`;

/**
 * Spreads children horizontally and centers them vertically
 */
export const SpreadContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const UnstyledLink = styled(Link)`
  text-decoration: none;
`;

export const StyledBackButton = styled(BackButton)`
  margin-left: 1rem;
  margin-bottom: 1rem;
`;
